import { instance } from "apis/interceptor";
import { TMember, TUser, TWorkspace } from "types/user.types";

type ResponseType<T> = {
  success: boolean;
  message?: string;
  statusCode?: number;
  data?: T;
};

export type TCompleteUser = TUser & {
  member?: TMember & {
    workspace?: TWorkspace;
  };
};

export const getUserInfo = async (): Promise<{ success: boolean; user?: TCompleteUser; message?: string }> => {
  try {
    const res = await instance.get("/users/info");
    return { success: true, user: res.data as TCompleteUser };
  } catch (error) {
    return { success: false, message: `${error}` };
  }
};

export const revokeUser = async () => {
  try {
    const res = await instance.delete("/auth/user");
    return { success: res.data.result };
  } catch (error: any) {
    return { success: false };
  }
};

//FEAT: (new) 회원 탈퇴 가능성 확인
export const checkAccountDeletionPermission = async (): Promise<ResponseType<{
  isPossibleToDeleteUser: boolean;
  impossibleToDeleteWorkspaceNames: string[];
}>> => {
  try {
    const res = await instance.get("/auth/user/check-possible-to-delete");
    return { success: true, data: res.data};
  } catch (error: any) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};
